export const SIDEBAR_COLLAPSED_STORE_KEY = "arka.sidebarCollapsed";
